import {
  addXDestinationHandlerHeaderTransformer,
  addXRequestedByHeaderTransformer,
  buildUrlPrefixTransformer,
  includeCredentialsRequestTransformer,
} from "./RawApiClient";
import { getApiProxyOrigin, getApiProxyPath } from "./apiProxy";
const FUNCTION_NAME = "appShellProxyRequestTransformer";
let REACT_APP_GOLDEN_GATE = "false";
try {
  REACT_APP_GOLDEN_GATE = process.env.REACT_APP_GOLDEN_GATE || "false";
} catch (ex) {}
export default function appShellProxyRequestTransformer(serviceName) {
  if (typeof window === "undefined") {
    const message = `\`${FUNCTION_NAME}("${serviceName}")\` is only supported for browser clients.`;
    return r => {
      console.error(message); // tslint:disable-line:no-console
      return r;
    };
  }
  if (REACT_APP_GOLDEN_GATE === "true") {
    const message =
      `\`${FUNCTION_NAME}("${serviceName}")\` is not supported in Golden Gate. ` +
      `Use \`goldenGateRequestTransformer\` instead.`;
    return r => {
      console.error(message); // tslint:disable-line:no-console
      return r;
    };
  }
  const urlPrefixTransformer = buildUrlPrefixTransformer(
    getApiProxyOrigin(),
    getApiProxyPath().substring(1),
    serviceName
  );
  return urlAndInit =>
    addXDestinationHandlerHeaderTransformer(
      addXRequestedByHeaderTransformer(
        includeCredentialsRequestTransformer(urlPrefixTransformer(urlAndInit))
      )
    );
}
